import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";

// Admin — müşteri yaşam döngüsü: askıya al / geri aç / sil (soft|hard).
export const suspendClient = createAction(
  "SUSPEND_CLIENT",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    body: {},
    url: "/api/admin/ClientLifecycle/" + id + "/suspend",
  })
);
export const resumeClient = createAction(
  "RESUME_CLIENT",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    body: {},
    url: "/api/admin/ClientLifecycle/" + id + "/resume",
  })
);
export const purgeClient = createAction(
  "PURGE_CLIENT",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/ClientLifecycle/" + id + "/purge",
  })
);

const clientLifecycleSaga = [
  takeLatest<any>(suspendClient.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(resumeClient.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(purgeClient.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default clientLifecycleSaga;
